<div class="container-fluid ">
    <div class="row justify-content-center align-items-center">
        <mat-form-field class="col col-md-6">
            <input matInput placeholder="Sélectionner un utilisateur" [(ngModel)]="SearchedUser" [matAutocomplete]="auto" type="text" aria-label="Number" (keyup)="onKeyUp()">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="assignSelectedUser($event)" [displayWith]="displayFn" [compareWith]="compareWith">
                @for (u of UserList; track u) {
                <mat-option [value]="u">
                    {{u.FirstName}} {{u.LastName}} - {{u.Email}} - {{u.Phone}}
                </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        <div class="col-auto ms-1">
            <button appPreventDoubleClick color="accent" mat-raised-button (throttledClick)="openCreationBox()">
                Nouvel utilisateur
                <mat-icon class="material-symbols-outlined">add</mat-icon>
            </button>
        </div>
        <!-- <div class="col-auto ms-1">
            <button appPreventDoubleClick color="accent" mat-raised-button (throttledClick)="openLogAsBox()">
                Log As
            </button>
        </div> -->
    </div>
    <div class="row justify-content-center">
        @if (SelectedUser) {
        <div class="card w-50 my-3 p-0">
            <h5 class="card-header"> Informations utilisateur</h5>
            <div class="card-body">
                <div class="row">
                    <p class="col card-text text-end fst-italic">Email</p>
                    <p class="col card-text text-start">{{SelectedUser.Email}}</p>
                </div>
                <div class="row">
                    <p class="col card-text text-end fst-italic">Téléphone</p>
                    <p class="col card-text text-start">{{SelectedUser.Phone}}</p>
                </div>
                <div class="row">
                    <p class="col card-text text-end fst-italic">Prénom</p>
                    <p class="col card-text text-start">{{SelectedUser.FirstName}}</p>
                </div>
                <div class="row">
                    <p class="col card-text text-end fst-italic">Nom</p>
                    <p class="col card-text text-start">{{SelectedUser.LastName}}</p>
                </div>
                <div class="row d-flex justify-content-end no-gutters">
                    <button appPreventDoubleClick mat-mini-fab class="ms-3" color="accent" (throttledClick)="openLogAsBox(SelectedUser.Email)" matTooltip="Log In As {{SelectedUser.Email}}">
                         <mat-icon class="material-symbols-outlined">switch_account</mat-icon>
                    </button>
                    <button appPreventDoubleClick mat-mini-fab class="mx-3" color="primary" (throttledClick)="openCreationBox(SelectedUser)" matTooltip="Modifier {{SelectedUser.FirstName}} {{SelectedUser.LastName}}">
                        <mat-icon class="material-symbols-outlined">edit</mat-icon>
                    </button>
                    <button appPreventDoubleClick mat-mini-fab class="me-3" color="warn" (throttledClick)="deleteUser(SelectedUser)" matTooltip="Supprimer {{SelectedUser.FirstName}} {{SelectedUser.LastName}}">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        }
    </div>
    <div class="row justify-content-center">
        @if (SelectedUser) {
        <div class="card w-50 my-3 p-0">
            <h5 class="card-header"> Configuration utilisateur</h5>
            <mat-list>
                <div class="row justify-content-center mb-3">
                    <button class="col-auto" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="openClientSelectionBoxForNewClient()" [disabled]="">
                        Nouveau Client
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                    </button>
                </div>
                @for (c of SelectedUser?.ClientList; track c) {
                <mat-list-item>
                    <mat-icon class="material-symbols-outlined me-3">face</mat-icon>
                    {{c.Name}}
                    <button class="ms-3" appPreventDoubleClick mat-raised-button color="primary" (throttledClick)="openClientSelectionBoxForNewContracts(c)" [disabled]="">
                        Nouveaux Contracts
                        <mat-icon class="material-symbols-outlined">add</mat-icon>
                    </button>
                    <mat-icon class="material-symbols-outlined clickable hidden-element mx-2" (click)="deleteClient(c)">delete_outline</mat-icon>
                </mat-list-item>
                <mat-list class="ms-5">
                    @for (contract of c.ContractList; track contract) {
                    <div>
                        <mat-list-item>
                            <mat-icon class="material-symbols-outlined me-3">grading</mat-icon>
                            {{ contract.Name }}
                            <mat-icon class="material-symbols-outlined clickable hidden-element mx-2" (click)="deleteContract(contract, c)">delete_outline</mat-icon>
                        </mat-list-item>
                    </div>
                    }
                </mat-list>
                }
            </mat-list>

        </div>
        }
    </div>
</div>